module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-Italic-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-Italic-webfont.svg
// module id = 360
// module chunks = 0